import { render, staticRenderFns } from "./PreviousPolicyDetailsForPcod.vue?vue&type=template&id=f318ac24&scoped=true"
import script from "./PreviousPolicyDetailsForPcod.vue?vue&type=script&lang=js"
export * from "./PreviousPolicyDetailsForPcod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f318ac24",
  null
  
)

export default component.exports